import { Space } from 'antd';
import styled from 'styled-components';

export const RightAlignedSpace = styled(Space)`
  display: flex;
  justify-content: flex-end;
`;
